<section>
  <div class="flex justify-between items-end">
    <div>
      <h1>Teacher Details</h1>
    </div>
    <div class="flex items-center gap-3">
      <div class="dropdown dropdown-bottom dropdown-end">
        <div tabindex="0" role="button" class="btn btn-sm btn-primary border flex items-center">
          Actions <i class="ri-arrow-down-s-line"></i>
        </div>
        <ul tabindex="0"
          class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow mt-2 text-sm font-semibold">
          <li><a>Assign Courses</a></li>
          <li><a>Manage Permissions</a></li>
          <li><a class="text-red-500">Delete Teacher</a></li>
        </ul>
      </div>
    </div>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-3 gap-5 mt-5">
    <div class="lg:col-span-1 teacher-profile-scroll">
      @if (isFetching) {
      <div class="flex justify-center py-10">
        <app-loader></app-loader>
      </div>
      } @else if (teacherData) {
      <app-staff-student-common-profile-view [profileData]="teacherData"></app-staff-student-common-profile-view>
      } @else {
      <div class="p-5 bg-white rounded-lg border text-center text-sm text-zinc-500">
        No teacher details found.
      </div>
      }
    </div>

    <div class="lg:col-span-2">
      <div class="teacher-tabs">
        <button class="teacher-tab" [ngClass]="{'active': activeTab === 'analytics'}"
          (click)="activeTab = 'analytics'">Analytics</button>
        <button class="teacher-tab" [ngClass]="{'active': activeTab === 'courses'}"
          (click)="activeTab = 'courses'">Courses</button>
        <button class="teacher-tab" [ngClass]="{'active': activeTab === 'classes'}"
          (click)="activeTab = 'classes'">Classes</button>
        <button class="teacher-tab" [ngClass]="{'active': activeTab === 'activity'}"
          (click)="activeTab = 'activity'">Activity Log</button>
      </div>

      @if (activeTab === 'analytics') {
      <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4">
        <div class="teacher-card">
          <div class="teacher-card__header">
            <h3>Recently Viewed</h3>
          </div>
          <div class="teacher-card__body">
            @for (i of recentViewed; track $index) {
            <div class="recent-item">
              <div class="recent-thumb">
                <img [src]="i.img" alt="">
                <div class="recent-play"><i class="ri-play-fill"></i></div>
              </div>
              <div class="recent-meta">
                <span class="recent-title">{{i.title}}</span>
                <span class="recent-badge">{{i.class}}</span>
              </div>
            </div>
            }
          </div>
        </div>

        <div class="teacher-card">
          <div class="teacher-card__header">
            <h3>Upcoming sessions</h3>
            <button class="btn btn-xs btn-circle">+</button>
          </div>
          <div class="teacher-card__body">
            @for (i of upcomingSessions; track $index) {
            <div class="session-row">
              <div class="session-meta">
                <span class="session-date"><i class="ri-calendar-line"></i> {{i.date}}</span>
                <span class="session-time"><i class="ri-time-line"></i> {{i.time}}</span>
                <span class="session-title">{{i.title}}</span>
              </div>
              <span class="session-badge">{{i.badge}}</span>
            </div>
            }
            <div class="text-right mt-2">
              <a class="text-xs text-blue-600 cursor-pointer">...see more</a>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5">
        <app-classroom-syllabus-card></app-classroom-syllabus-card>
      </div>
      }

      @if (activeTab === 'courses') {
      <div class="teacher-card mt-4">
        <div class="teacher-card__header">
          <h3>Course Name</h3>
        </div>
        <div class="teacher-table">
          @for (i of courses; track $index) {
          <div class="teacher-row">
            <div class="teacher-row__name">{{i.name}}</div>
            <div class="teacher-row__classes">{{i.classes}}</div>
            <div class="teacher-row__actions">
              <button class="btn btn-xs btn-circle"><i class="ri-pencil-line"></i></button>
              <button class="btn btn-xs btn-circle"><i class="ri-delete-bin-line"></i></button>
            </div>
          </div>
          }
        </div>
      </div>
      }

      @if (activeTab === 'classes') {
      <div class="teacher-card mt-4">
        <div class="teacher-card__header">
          <h3>Batches</h3>
        </div>
        <div class="teacher-card__body">
          @for (c of classBatches; track $index) {
          <div class="class-block">
            <button class="class-toggle">
              <i class="ri-arrow-down-s-line"></i> {{c.className}}
            </button>
            @if (c.batches.length) {
            <div class="batch-tabs">
              @for (b of c.batches; track $index) {
              <button class="batch-tab" [ngClass]="{'active': $index === 0}">{{b}}</button>
              }
            </div>
            <div class="progress-wrap">
              <span class="progress-text">{{c.progress}}%</span>
              <div class="progress-bar">
                <div class="progress-fill" [style.width.%]="c.progress"></div>
              </div>
            </div>
            <div class="thumb-strip">
              @for (t of c.thumbnails; track $index) {
              <div class="thumb-item">
                <img [src]="t" alt="">
              </div>
              }
            </div>
            } @else {
            <div class="text-xs text-zinc-400 ml-6 mt-2">No batches</div>
            }
          </div>
          }
        </div>
      </div>
      }

      @if (activeTab === 'activity') {
      <div class="teacher-card mt-4">
        <div class="teacher-card__header">
          <h3>Log</h3>
        </div>
        <div class="teacher-card__body">
          <div class="timeline">
            @for (i of activityLog; track $index) {
            <div class="timeline-row">
              <div class="timeline-time">
                <span>{{i.date}}</span>
                <span>{{i.time}}</span>
              </div>
              <div class="timeline-line">
                <span class="dot"></span>
                <span class="line"></span>
              </div>
              <div class="timeline-text">{{i.text}}</div>
              <div class="timeline-status" [ngClass]="{'ok': i.status === 'success', 'bad': i.status === 'error'}">
                <i class="ri-check-line" *ngIf="i.status === 'success'"></i>
                <i class="ri-close-line" *ngIf="i.status === 'error'"></i>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</section>
